module.exports = __webpack_public_path__ + "img/shot_bigtx20030601.73c5e081.png";